export default __webpack_public_path__ + "static/media/sideLogo.e52fb104.png";